import { store } from "../_helpers";

const UPDATE_VENDOR = "UPDATE_VENDOR";

export const loginTypeActions = {
  updateVendor,
};

function updateVendor(data) {
  store.dispatch({ type: UPDATE_VENDOR, data });
}

export function logintype(state = initialState, action) {
  switch (action.type) {
    case UPDATE_VENDOR:
      return {
        vendor: action.data,
      };
    default:
      return state;
  }
}

const initialState = {
  vendor: false,
};